module.exports = __webpack_public_path__ + "dist/img/biznis-product.93e5cc6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/biznis-product.png
// module id = M+Y3
// module chunks = 1